{
  "endTime": "Vrijeme završetka",
  "startTime": "Vrijeme početka",
  "time": "Vrijeme"
}
